 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		247: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"4d6a8a0","1":"92c6103","2":"25da2cb","3":"72a489b","4":"9323cee","5":"e22b553","6":"be7f27c","7":"9162e91","8":"53683ab","9":"700a58b","10":"0c902f7","11":"ce40b75","12":"9c32395","13":"83fc6ad","14":"0507aeb","15":"9c3fbe8","16":"24a4136","17":"25d8f16","18":"6601fd7","19":"0cedd4c","20":"b90a157","21":"3f9bdb2","22":"54b3e20","23":"53ef3fd","24":"d8bfd5a","25":"9739400","26":"0062281","27":"31d64df","28":"7534902","29":"73960c9","30":"1f8e9d7","31":"79894cb","32":"5338218","33":"052934f","34":"065b1a8","35":"bc26d52","36":"56e66de","37":"db42a7a","38":"fa62268","39":"36ac23a","40":"763884d","41":"f88d81b","42":"bd874d3","43":"1d1b2f5","44":"7092fe8","45":"a561412","46":"807137b","47":"704d25b","48":"056dfea","49":"c2acddb","50":"5303013","51":"6cba109","52":"1e0c411","53":"a489ee1","54":"44f8629","55":"6b7cb1c","56":"e0d7864","57":"51810f1","58":"8d7abf5","59":"3d6f541","60":"f0c6810","61":"4b0b78e","62":"7a02093","63":"0d20cfe","64":"f2ca3af","65":"7fd49a4","66":"93a666a","67":"48e0aba","68":"8c60ef2","69":"42e70ea","70":"a293c97","71":"6cadeb0","72":"b00c424","73":"718db74","74":"69df11b","75":"aa7e721","76":"8abd49b","77":"963e89b","78":"68a7abc","79":"b68de7a","80":"ce54c59","81":"4386ce9","82":"cb6558c","83":"149b218","84":"1a40d59","85":"96f6cec","86":"a529105","87":"01d9893","88":"3f24de9","89":"b5f2bcd","90":"57e8497","91":"2a8c223","92":"4a8c001","93":"e710238","94":"c66ebb1","95":"4f62ad2","96":"7326773","97":"4f66016","98":"d4007c1","99":"863e9b6","100":"4455498","101":"32b1059","102":"4235ede","103":"2eaf1c3","104":"550dd71","105":"1652871","106":"cf5c9de","107":"fea330e","108":"7171413","109":"8202e4f","110":"521f413","111":"f0b063d","112":"3ce7e1e","113":"728158a","114":"3733d34","115":"6ad3ade","116":"ac83040","117":"d7aa634","120":"d60b039","121":"f7e2974","122":"a755375","123":"844a00d","124":"b876f64","125":"7594cb8","126":"79dca7a","127":"a1ed755","128":"a052e72","129":"8dfeb64","130":"58de4a0","131":"38f5029","132":"2b3c466","133":"02f3bc3","134":"6fe09f6","135":"7ebe78a","136":"17347f4","137":"c26ec55","138":"69f6d8d","139":"4f53035","140":"51e1127","141":"ef43487","142":"aeb5cd9","143":"dae53af","144":"1bce61c","145":"8dd0f56","146":"ae8084c","147":"90c405a","148":"badf265","149":"428b2de","150":"22be14d","151":"45a9b92","152":"b854929","153":"c89ed85","154":"8a24e41","155":"27806b2","156":"55e7baf","157":"6178afa","158":"eb260ad","159":"94194aa","160":"82efd49","161":"7870199","162":"7d36e99","163":"4661fcb","164":"0280536","165":"224ffad","166":"a10ca24","167":"2443490","168":"388cbfd","169":"df4e722","170":"05c2499","171":"92270d5","172":"e882c72","173":"20a3436","174":"b599cec","175":"83024ca","176":"9d6a4ae","177":"9a18813","178":"2c244d9","179":"d9f0d72","180":"a8fc332","181":"5b46574","182":"ffe050a","183":"a68ebb2","184":"300201d","185":"24e886d","186":"edebae1","187":"bdf5496","188":"3996b98","189":"9ad06db","190":"d369a19","191":"fb081bb","192":"9fc13c1","193":"9eeabd1","194":"38d9d0e","195":"34ac932","196":"1611bb7","197":"b342a7a","198":"78384ed","199":"5359880","200":"dd8cefb","201":"3f671c3","202":"72e5152","203":"3739108","204":"78ce4f6","205":"0c9379c","206":"8f40cd9","207":"4b98c00","208":"1f1a960","209":"9a05eca","210":"a790de4","211":"17b7913","212":"2715453","213":"f9834ee","214":"16dc976","215":"42ab69b","216":"7307813","217":"f43011f","218":"453db49","219":"1039a99","220":"8eb0271","221":"0e3ee5e","222":"08a6dfd","223":"114f6e8","224":"ba217ca","225":"b33cf1e","226":"a0d249f","227":"31b2066","228":"8745972","229":"57f9c25","230":"ec4b9c4","231":"8c142f6","232":"e4ed3e8","233":"dcab77d","234":"97c0089","235":"9b00bf9","236":"595c24c","237":"ae23729","238":"533f115","239":"bc9c082","240":"08400cb","241":"d853ce6","242":"2be6cc6","243":"4180830","244":"f5c1b78","245":"5352725","246":"26758a5","249":"ce6a6c5","250":"14a3952","251":"2ccc5be","252":"3448dba","253":"86e4410","254":"5839395","255":"84f4fe3","256":"3ecf907","257":"24a54a2","258":"dcb77c4","259":"8e4edb0","260":"206c2e2","261":"14bf8ae","262":"45e13c1","263":"34aba73","264":"06fe9ab","265":"b181e09","266":"1824cf6","267":"72cb436","268":"b0b9d2b","269":"1dddfdd","270":"f16013a","271":"636d3bb","272":"6a5d5a8","273":"0597612","274":"af0481e","275":"d3fae11","276":"53eded8","277":"199eaaa","278":"0500cdb","279":"6cd3f54","280":"742f8a4","281":"242150a","282":"f186834","283":"68e89d4","284":"62199c0","285":"7d1d651","286":"d218dbb","287":"7bcde3d","288":"a0158e4","289":"88b88f5","290":"67d07b6","291":"0fed8cb","292":"6559633","293":"2acf947","294":"af52ee9","295":"3fd9d74","296":"10fb09e","297":"d9042a2","298":"6414ad4","299":"760eab9","300":"fb78d3c","301":"204606e","302":"ace7fe5","303":"aa2b249","304":"c8c8007","305":"c9358cb","306":"8fd778e","307":"3661f72","308":"9814576","309":"2212560","310":"c699abe","311":"1a97984","312":"154b6c9","313":"89ee3c9","314":"672be6e","315":"9adca9e","316":"6c0097d","317":"ce36709","318":"910940d","319":"f614783","320":"a0d566a","321":"d1a4657","322":"f7a8d0e","323":"37f2197","324":"7427d60","325":"b47f0d8","326":"ed68b95","327":"6eb5a0b","328":"4a1dde5","329":"e6b4943","330":"f9ef5ef","331":"a665b00","332":"9804f5b","333":"2d114c7","334":"5b76ee2","335":"944639e","336":"eec1699","337":"c8da131","338":"9dbb165","339":"b9a6ad5","340":"a1d7d28","341":"118e277","342":"3d09453","343":"b6a9912","344":"73dba51","345":"f3e0b65","346":"bbf2831","347":"b885323","348":"4c78a3b","349":"5c00c37","350":"e3a4dcb","351":"71af8ee","352":"3d3e272","353":"79a4e67","354":"ee44973","355":"3dfa746","356":"cf91f2d","357":"9108094","358":"00aac59","359":"34fdf5a","360":"0dc56fe","361":"c5d374c","362":"86e0ad8","363":"242e682","364":"f5565a8","365":"23cf1cf","366":"cac76ae","367":"05a92b4","368":"c6e9a23","369":"d4ce7e4","370":"c413f50","371":"4c6396d","372":"a33985f","373":"3ab2837","374":"b28179d","375":"1088215","376":"f0e763b","377":"5920531","378":"7fdd111","379":"9028cc1","380":"ff7f0b5","381":"d852e20","382":"4001c8e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
